<template>

<div class="leftnav" :style="'height:'+ (innerHeight-60)+'px;'">
      <ul >
     
          <li class="home_icon"><router-link to="/Home"> <img src="../assets/images/shouye.png"/>首页</router-link></li>
          <!-- <li><router-link to="/bar"> <img src="../assets/images/shangpinguanli.png"/>商品价格</router-link></li> -->
          <!-- <li @click="open()">
            <img src="../assets/images/kehuguanli.png"/>
              门店信息
              <ul v-show="isShow">
                <li><router-link to="">Go to Bar  </router-link></li>
                <li><router-link to="">Go to Bar  </router-link></li>
              </ul>
          </li>  -->
      </ul>
        <!-- <leftnav></leftnav>   -->
</div>
</template>

<script >
  import data from '../homeDataMethods/homeData'
  export default {
    name:"app",
    data:function () {
      return data;
    },
    components:{},

    methods:{
      open(){
        this.isShow = !this.isShow;
      }
    }
  }
</script>

<style  scoped>
    .home-icon{
        margin-right: -5px;
    }
    .leftnav li a{
        width: 100%;
        height: 30px;
        font-size: 14px;
        display: block;
        line-height: 30px;
        text-align: left;
        text-indent: 14px;
    }
    .leftnav li {
        color: white;
        font-size: 14px;
        cursor: pointer;
         line-height: 30px;
        text-align: left;
        text-indent: 10px;
    }
    .leftnav li img{
        width: 20px;
        float: left;
        margin-top: 5px;
        margin-left: 15px;
    }
     .leftnav li a img{
        width: 20px;
        float: left;
        line-height: 30px;     
        margin-top: 5px;
        margin-left: 15px;
     }
     .home_icon{
       margin-top: 10px;
       margin-bottom: 10px;
     }
</style>









// WEBPACK FOOTER //
// src/components/leftNav.vue